import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-tab-header',
  templateUrl: './tab-header.component.html',
  styleUrls: ['./tab-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class TabHeaderComponent {
  readonly title = input<string>('');

  constructor() {
  }
}